import { render, staticRenderFns } from "./penEdit.vue?vue&type=template&id=6c44e66a&"
import script from "./penEdit.vue?vue&type=script&lang=js&"
export * from "./penEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports